import { DropdownOption } from "presentation/view/components/NbisInputDropDown";

export enum ReportPermission {

    ARCSTMRPT01 = 'Audit Trail for Company',
    ARCSTMRPT02 = 'Audit Trail for Customer',
    ARCSTMRPT03 = 'Audit Trail for Proposal',

    BLRPT01 = 'Invoice Register',
    // BLRPT02 = 'BLRPT02',
    BLRPT03 = 'Credit Note Summary',
    BLRPT04 = 'Throughput by Company',
    BLRPT05 = 'Exception Report',
    BLRPT06 = 'Criteria Checklist',
    BLRPT07 = 'Voyage Update Discrepancy Report',
    BLRPT08 = 'T3 Invoice Revenue Report',
    // BLRPT09 = 'BLRPT09',
    BLRPT10 = 'Invoice Summary (Operation) Report',
    BLRPT11 = 'Invoice Summary (Non Operation) Report',
    BLRPT12 = 'Summary of Customer Monthly Balance',
    BLRPT13 = 'Manual/Adjustment Credit Notes Summary',
    BLRPT14 = 'Movements Per Line',
    BLRPT15 = 'Movements Per Ship Owner',
    BLRPT16 = 'Billing By Client and Concept',
    BLRPT17 = 'Comparative between TEUs',
    BLRPT18 = 'TEUs Billed',
    BLRPT19 = 'Vessel movements report',
    BLRPT20 = 'Output Statistics',
    BLRPT21 = 'Billing Comparative',
    BLRPT22 = 'Rail Movement',
    BLRPT23 = 'Movement List',
    BLRPT24 = 'Price Changes List',
    BLRPT25 = 'Throughput By Line Report',
    // BLRPT26 = 'BLRPT26',
    // BLRPT27 = 'BLRPT27',
    // BLRPT28 = 'BLRPT28',
    BLRPT29 = 'Pre-Cool Without Vessel Information',
    BLRPT30 = 'Container Un-Billed / Billed THC Report',
    // BLRPT31 = 'Daily Invoice Summary', // ECT
    // BLRPT32 = 'Tax Report', // ECT

    COLLRPT03 = 'LPA Account Analysis',
    COLLRPT04 = 'LPA Daily Deposit Report',

    EMRPT01 = 'Empty Container Summary Report',
    EMRPT02 = 'Empty Pool Container List Report',

    FLPRPT01 = 'Full Container Summary Report',
    FLPRPT02 = 'Full Pool Container List Report',

    GPRPT01 = 'Credit Notes Summary Report',
    GPRPT02 = 'Invoice Summary Report',
    GPRPT03 = 'GPRPT03',
    GPRPT04 = 'Receival and Delivery Charges Summary',
    GPRPT05 = 'Volume Discount Report',
    GPRPT06 = 'Let Pass Account Monthly Statement',
    GPRPT07 = 'Sales Tax Report',
    GPRPT08 = 'Free Pool Volume',
    GPRPT09 = 'Daily Yard Inventory',
    GPRPT10 = 'GPRPT10',
    GPRPT11 = 'Billing Statistics Report',
    GPRPT12 = 'CC Invoice/Credit Note Summary Report',
    GPRPT13 = 'CC Invoice/Credit Note Summary Report',
    GPRPT14 = 'Output VAT Report',
    GPRPT15 = 'GPRPT15',

    TRRPT01 = 'Company Master Report',
    TRRPT02 = 'Tariff item Mapping List',
    TRRPT03 = 'Proposal Master Report',
    TRRPT04 = 'Tariff Proposal Expiring Notice',

    TARPT01 = 'Tariff Adjustment Report',

    R081 = 'Revenue Analysis Per Shipping Line Per Tariff Item',

    RARPT01 = 'Operation Revenue Report',
    RARPT02 = 'Revenue Analysis By Customer Report',
    RARPT03 = 'Revenue Analysis by Terminal Report',
    RARPT04 = 'Revenue Analysis Exception Report',
    RARPT05 = 'Consolidation of R/A Report',
    RARPT06 = 'Reconciliation by Account Number',
    RARPT07 = 'Reconciliation Summary by Account Number',
    RARPT08 = 'Cash Reconciliation',
    RARPT09 = 'User Wise Collection Report',
    RARPT10 = 'Revenue Report on Demurrage including Variance Analysis',
    RARPT11 = 'Daily Reconciliation of Posting of nBISIV in EBIS',

    SIMRPT01 = 'Storage and Reefer Charge Simulation Report',

}

export const ReportView = {
    AUDIT_TRAIL_REPORT: 'Audit Trail Report',
    GENERAL_REPORT: 'General Report',
    FINANCIAL_REPORT: 'Financial Report',
    GENERAL_CSV_REPORT: 'General CSV Report',
    REVENUE_RECONCILIATION_REPORT: 'Revenue Reconciliation Report',
} as const;

export const ReportViewConfigurations = {
    SAPT: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [
            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            // ReportPermission.BLRPT02,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.GPRPT11,
            ReportPermission.COLLRPT03,
            ReportPermission.COLLRPT04,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
        ],
    },
    KICT: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [
            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            // ReportPermission.BLRPT02,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.GPRPT11,
            ReportPermission.COLLRPT03,
            ReportPermission.COLLRPT04,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
        ],
    },

    OICT: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [

            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.GPRPT12,
            ReportPermission.GPRPT11,
            ReportPermission.FLPRPT01,
            ReportPermission.FLPRPT02,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.RARPT08,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
            ReportPermission.GPRPT14,
        ],
    },
    HPJZ: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [

            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.GPRPT12,
            ReportPermission.GPRPT11,
            ReportPermission.FLPRPT01,
            ReportPermission.FLPRPT02,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.RARPT08,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
            ReportPermission.GPRPT14,
        ],
    },
    AQCT: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [

            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.GPRPT12,
            ReportPermission.GPRPT11,
            ReportPermission.FLPRPT01,
            ReportPermission.FLPRPT02,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.RARPT08,
            ReportPermission.R081,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
            ReportPermission.GPRPT14,
        ],
    },
    RSCT: {
        [ReportView.AUDIT_TRAIL_REPORT]: [
            ReportPermission.ARCSTMRPT01,
            ReportPermission.ARCSTMRPT02,
            ReportPermission.ARCSTMRPT03,
        ],
        [ReportView.GENERAL_REPORT]: [

            ReportPermission.TRRPT01,
            ReportPermission.TRRPT02,
            ReportPermission.TRRPT03,
            ReportPermission.BLRPT01,
            ReportPermission.BLRPT03,
            ReportPermission.BLRPT06,
            ReportPermission.BLRPT05,
            ReportPermission.BLRPT08,
            ReportPermission.BLRPT10,
            ReportPermission.BLRPT11,
            ReportPermission.BLRPT12,
            ReportPermission.BLRPT13,
            ReportPermission.TARPT01,
            ReportPermission.BLRPT25,
            ReportPermission.BLRPT29,
            ReportPermission.GPRPT02,
            ReportPermission.BLRPT30,
            ReportPermission.GPRPT01,
            ReportPermission.GPRPT04,
            ReportPermission.GPRPT05,
            ReportPermission.GPRPT06,
            ReportPermission.GPRPT07,
            ReportPermission.GPRPT12,
            ReportPermission.GPRPT11,
            ReportPermission.FLPRPT01,
            ReportPermission.FLPRPT02,
            ReportPermission.EMRPT01,
            ReportPermission.EMRPT02,
            ReportPermission.RARPT08,
            ReportPermission.R081,
        ],
        [ReportView.FINANCIAL_REPORT]: [
            ReportPermission.BLRPT14,
            ReportPermission.BLRPT15,
            ReportPermission.BLRPT16,
            ReportPermission.BLRPT17,
            ReportPermission.BLRPT18,
            ReportPermission.BLRPT19,
            ReportPermission.BLRPT20,
            ReportPermission.BLRPT21,
            ReportPermission.BLRPT22,
            ReportPermission.BLRPT23,
            ReportPermission.BLRPT24,
            ReportPermission.SIMRPT01,
        ],
        [ReportView.GENERAL_CSV_REPORT]: [
            ReportPermission.GPRPT08,
            ReportPermission.GPRPT09,
            ReportPermission.GPRPT14,
        ],
    },
} as const;

export type ReportPermissionKey = keyof typeof ReportPermission;

/**
 * Obtain the permission value based on the permission code
 */
export const getPermissionValueByCode = (code: string): string | undefined => {
    const isValidKey = Object.keys(ReportPermission).some(key =>
        key === code && isNaN(Number(key))
    );

    if (isValidKey) {
        return ReportPermission[code as ReportPermissionKey];
    }

    return code;
};

// Tool function: Retrieve the key (permission code) from the enumeration value
const getPermissionCodeFromValue = (permissionValue: string): string => {
    const entry = Object.entries(ReportPermission).find(([key, value]) => value === permissionValue);
    return entry ? entry[0] : permissionValue;
};

// Permission ID Generator
const generatePermissionId = (view: string, permissionValue: string): string => {
    return `${view}-${permissionValue}`;
};

export const generatePermissionByRptId = (view: string, rptId: string): string => {
    return generatePermissionId(view, getPermissionValueByCode(rptId) ?? rptId);
};

// Permission display information generator
export const getPermissionDisplayInfo = (
    bu: string,
    view: string,
    permissionValue: string
): {
    dropdownLabel: string;
    tagLabel: string;
    value: string;
} => {
    const buConfig = ReportViewConfigurations[bu as keyof typeof ReportViewConfigurations];

    if (!buConfig) {
        throw new Error(`No configuration found for BU: ${bu}`);
    }

    // Check whether this view is included in the current BU configuration.
    const viewPermissions = buConfig[view as keyof typeof buConfig] as readonly string[];
    if (!viewPermissions) {
        throw new Error(`View ${view} is not configured for BU ${bu}`);
    }


    if (!(viewPermissions as string[]).includes(permissionValue)) {
        throw new Error(`Permission ${permissionValue} is not available for view ${view} in BU ${bu}`);
    }

    const rptPermission = generatePermissionId(view, permissionValue);
    return {
        dropdownLabel: rptPermission,
        tagLabel: rptPermission,
        value: rptPermission
    };
};

export const getBuReportPermissionDropdownOptions = (currentBu: string): DropdownOption[] => {
    const buConfig = ReportViewConfigurations[currentBu as keyof typeof ReportViewConfigurations];

    if (!buConfig) {
        console.warn(`No configuration found for BU: ${currentBu}`);
        return [];
    }

    const options: DropdownOption[] = [];


    Object.entries(buConfig).forEach(([view, permissionValues]) => {
        // Traverse all the permission values under this view
        permissionValues.forEach((permissionValue: string) => {
            try {
                const permissionInfo = getPermissionDisplayInfo(currentBu, view, permissionValue);

                options.push({
                    dropdownLabel: permissionInfo.dropdownLabel,
                    tagLabel: permissionInfo.tagLabel,
                    value: permissionInfo.value
                });
            } catch (error) {
                console.error(`Error processing permission ${permissionValue} for view ${view}:`, error);
            }
        });
    });

    return options;
};

// The option for obtaining permission for a specific view
export const getViewPermissionDropdownOptions = (
    currentBu: string,
    view: string
): DropdownOption[] => {
    const buConfig = ReportViewConfigurations[currentBu as keyof typeof ReportViewConfigurations];

    if (!buConfig) {
        console.warn(`No configuration found for BU: ${currentBu}`);
        return [];
    }

    const viewPermissions = buConfig[view as keyof typeof buConfig];

    if (!viewPermissions) {
        console.warn(`View ${view} is not configured for BU ${currentBu}`);
        return [];
    }

    const options: DropdownOption[] = [];

    viewPermissions.forEach(permissionValue => {
        try {
            const permissionInfo = getPermissionDisplayInfo(currentBu, view, permissionValue);

            options.push({
                dropdownLabel: permissionInfo.dropdownLabel,
                tagLabel: permissionInfo.tagLabel,
                value: permissionInfo.value
            });
        } catch (error) {
            console.error(`Error processing permission ${permissionValue}:`, error);
        }
    });

    return options;
};


